/**
 * Standard initial-state builder for scoped Zustand stores.
 *
 * - `makeDefaults` is invoked per call — every call to the returned factory
 *   gets fresh `Map`/array references, so independent store instances (and
 *   independent `reset()` calls) never share mutable state.
 * - Exact spread semantics: override keys win, INCLUDING keys explicitly set
 *   to `undefined` (do not "fix" this with `??` or key-existence checks — the
 *   explicit-`undefined` passthrough is load-bearing for callers that seed
 *   from possibly-incomplete saved state).
 * - Compile-time caveat (code review): if this repo ever enables
 *   `exactOptionalPropertyTypes`, `Partial<T>` stops accepting explicit
 *   `undefined` — callers relying on the passthrough will need `| undefined`
 *   on the affected fields (or a cast) to keep this contract compiling.
 */
export const withDefaults =
  <T extends object>(makeDefaults: () => T) =>
  (overrides: Partial<T> = {}): T => ({
    ...makeDefaults(),
    ...overrides
  });
